import PostApiBase from "@/modules/post/services/ApiBase"

export default class Api {
    static syncSlugByTitle(postId, title) {
        return PostApiBase.syncSlugByTitle({
            post_id: postId,
            title: title,
        })
    }
}
